export { SkyHelpInlineComponent } from './help-inline.component';
export { SkyHelpInlineModule } from './help-inline.module';
